import { render } from "./BrandMenu.vue?vue&type=template&id=11a85d5e&scoped=true"
import script from "./BrandMenu.vue?vue&type=script&lang=js"
export * from "./BrandMenu.vue?vue&type=script&lang=js"

import "../_css/sidebarmenu.scss?vue&type=style&index=0&id=11a85d5e&lang=scss&scoped=true&external"
import "./BrandMenu.vue?vue&type=style&index=1&id=11a85d5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a85d5e"]])

export default __exports__